export const FETCH_CHAT_STATISTICS_REQUEST = 'STATISTICS/CHAT/FETCH_REQUEST';
export const FETCH_CHAT_STATISTICS_SUCCESS = 'STATISTICS/CHAT/FETCH_SUCCESS';
export const FETCH_CHAT_STATISTICS_FAILURE = 'STATISTICS/CHAT/FETCH_FAILURE';

export const STATISTICS_LOCATION_CHANGE = 'STATISTICS/LOCATION_CHANGE';

export const FETCH_DASHBOARD_SELF_SERVICE_STATS = 'STATISTICS/SELF_SERVICE/DASHBOARD/REQUEST';
export const FETCH_DASHBOARD_SELF_SERVICE_STATS_SUCCESS = 'STATISTICS/SELF_SERVICE/DASHBOARD/SUCCESS';
export const FETCH_DASHBOARD_SELF_SERVICE_STATS_FAILURE = 'STATISTICS/SELF_SERVICE/DASHBOARD/FAILURE';

export const FETCH_DETAILS_SELF_SERVICE_STATS = 'STATISTICS/SELF_SERVICE/DETAILS/REQUEST';
export const FETCH_DETAILS_SELF_SERVICE_STATS_SUCCESS = 'STATISTICS/SELF_SERVICE/DETAILS/SUCCESS';
export const FETCH_DETAILS_SELF_SERVICE_STATS_FAILURE = 'STATISTICS/SELF_SERVICE/DETAILS/FAILURE';

export const SET_DETAILS_STATS_SELF_SERVICE_FILTERS = 'STATISTICS/SELF_SERVICE/DETAILS/SET_FILTERS';

export const SET_EXTRA_FILTER = 'SET_EXTRA_FILTER';
export const SET_SELECTED_SELF_SERVICE_TAB = 'SET_SELECTED_SELF_SERVICE_TAB';

export const FETCH_EXTRA_DETAILS_STATS = 'STATISTICS/EXTRA/DETAILS/REQUEST';
export const FETCH_EXTRA_DETAILS_STATS_SUCCESS = 'STATISTICS/EXTRA/DETAILS/SUCCESS';
export const FETCH_EXTRA_DETAILS_STATS_FAILURE = 'STATISTICS/EXTRA/DETAILS/FAILURE';

export const SET_PROACTIVE_WORKS_FILTER = 'STATISTICS/SET_PROACTIVE_WORKS_FILTER';

export const SET_SELF_SERVICE_TOP_CONTRIBUTORS_FILTER = 'STATISTICS/SET_SELF_SERVICE_TOP_CONTRIBUTORS_FILTER';

export const FETCH_PROACTIVE_WORKS_DETAILS_STATS = 'STATISTICS/PROACTIVE_WORKS/DETAILS/REQUEST';
export const FETCH_PROACTIVE_WORKS_DETAILS_STATS_SUCCESS = 'STATISTICS/PROACTIVE_WORKS/DETAILS/SUCCESS';
export const FETCH_PROACTIVE_WORKS_DETAILS_STATS_FAILURE = 'STATISTICS/PROACTIVE_WORKS/DETAILS/FAILURE';

export const FETCH_AUDIT_IN_FILES_TABLE_REQUEST = 'STATISTICS/AUDIT_IN_FILES/TABLE/REQUEST';
export const FETCH_AUDIT_IN_FILES_TABLE_SUCCESS = 'STATISTICS/AUDIT_IN_FILES/TABLE/SUCCESS';
export const FETCH_AUDIT_IN_FILES_TABLE_FAILURE = 'STATISTICS/AUDIT_IN_FILES/TABLE/FAILURE';

export const FETCH_AUDIT_IN_FILES_SUMMARY_REQUEST = 'STATISTICS/AUDIT_IN_FILES/SUMMARY/REQUEST';
export const FETCH_AUDIT_IN_FILES_SUMMARY_SUCCESS = 'STATISTICS/AUDIT_IN_FILES/SUMMARY/SUCCESS';
export const FETCH_AUDIT_IN_FILES_SUMMARY_FAILURE = 'STATISTICS/AUDIT_IN_FILES/SUMMARY/FAILURE';
